var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"title wi8_font"},[_vm._v("Single Article Builder")]),_c('ArtDetail')],1)}
var staticRenderFns = []

export { render, staticRenderFns }